(ns app.front.view.group.admin.templates.system-email
  (:require [app.front.clipboard :as clipboard]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.blip :as ui-blip]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.permission.resolver :as permission-resolver]))

(def system-email-tab-param "system-emails")

(defn- superdomain? [group]
  (= :group.type/superdomain (:group/type group)))

(defn- parent-template-key [parent-group organization-key shared-services-key]
  (if (superdomain? parent-group)
    shared-services-key
    organization-key))

(defn list-view [tr group-id]
  (let [templates        (<sub [::template-subs/system-email-templates group-id])
        format-date-time (<sub [::date-util/date-time-fn])
        lang             (<sub [:language])]
    (when (seq templates)
      [sortable-table/table
       {:id            "system-email-templates"
        :tr            tr
        :class         "mt-8"
        :cols          [[(tr [:system-email-template/category]) #(tr [(:category %)]) {:sorting true}]
                        [(tr [:system-email-template/name]) #(tr [(:name %)]) {:sorting true}]
                        [(tr [:system-email-template/subject])
                         (fn [{:keys [subject custom-subjects]}]
                           (if (seq custom-subjects)
                             (i18n-model/get-text-from-entities-or-map custom-subjects lang)
                             (tr [subject])))
                         {:sorting true}]
                        [(tr [:system-email-template/status]) #(if (:edited? %)
                                                                 (tr [:system-email-template/edited])
                                                                 (tr [:system-email-template/default])) {:sorting true}]
                        [(tr [:system-email-template/edited-by]) #(or (:modified-by %) "") {:sorting true}]
                        [(tr [:system-email-template/edited-at]) #(some-> % :modified-ts format-date-time) {:sorting true}]]
        :items         templates
        :id-func       :email-type
        :configurable? true
        :link          {:description (tr [:open])
                        :make-href   #(href/href :view/group.admin.system-email-template
                                                 {:group-id   group-id
                                                  :email-type (:email-type %)})}}])))

(defn template-breadcrumb [{:keys [tr match]}]
  (let [params   (-> match :parameters :path)
        group-id (:group-id params)
        template (<sub [::template-subs/system-email-template group-id (:email-type params)])]
    [:view/group.admin.system-email-template
     params
     (or (some-> (:name template) vector tr)
         (tr [:system-email-template/system-emails]))]))

(defn templates-breadcrumb [{:keys [tr match]}]
  (let [params (-> match :parameters :path)]
    [:view/group.admin.templates
     {:group-id (:group-id params)}
     (tr [:system-email-template/system-emails])
     {:tab system-email-tab-param}]))

(defn organization-templates-link [tr group]
  (let [parent-group (:entity/parent group)]
    (when (and parent-group
               (permission-resolver/permitted? parent-group
                                               (<sub [:session/user])
                                               :permission.group/admin))
      [:div.mt-2
       (cc/link {:href (href/href :view/group.admin.templates
                                  {:group-id (:db/id parent-group)}
                                  {:tab system-email-tab-param})}
                (tr [(parent-template-key parent-group
                                          :system-email-template/view-organization-templates
                                          :system-email-template/view-shared-services-templates)]))])))

(defn- placeholder-view [tr {:keys [description-key id]}]
  [ui-blip/blip
   (fn [show-blip]
     [:li.my-2.rounded.p-2.flex.items-center.bg-ui-blue-10.hover:bg-gray-400.cursor-pointer
      {:on-click #(do
                    (show-blip (tr [:copied]))
                    (clipboard/copy-text (str "%" id "%")))}
      [:div.flex-1>div.flex.flex-wrap.items-baseline
       [:h5.mr-2 (tr [description-key])]
       [:div.whitespace-nowrap.font-mono id]]
      (cc/icon {:description (tr [:template-editor/copy-placeholder])
                :icon        i/link})])])

(defn- localized-value-or-default [values lang default-value]
  (get values lang (or default-value "")))

(defn- preview-value [preview k]
  (or (get preview k)
      (get preview (name k))))

(defn- html-data-url [html]
  (str "data:text/html;charset=utf-8," (js/encodeURIComponent (or html ""))))

(defn editor-view [match]
  (let [tr                                (<sub [::gas/group-tr])
        {:keys [group-id
                email-type]}              (-> match :parameters :path)
        enabled?                          (<sub [::ff/enabled? :feature-flag.id/system-email-templates])
        {:keys [attachments
                placeholders
                subject-readonly?
                default-subjects
                default-bodies
                inherited-subjects
                inherited-bodies]
         :as   template}                  (<sub [::template-subs/system-email-template group-id email-type])
        {:keys [inherit-from-organization
                subjects
                editor-version
                bodies]}                  (<sub [::template-subs/system-email-template-draft group-id email-type])
        dirty?                            (<sub [::template-subs/system-email-template-dirty? group-id email-type])
        preview                           (<sub [::template-subs/system-email-template-preview])
        group                             (<sub [::gas/group])
        parent-group                      (:entity/parent group)
        language                          (<sub [::ui-i18n/editor-language ::gas/allowed-locales])
        inherit?                          (boolean inherit-from-organization)
        default-subj                      (get default-subjects language)
        default-body                      (get default-bodies language)
        subject                           (if inherit?
                                            (localized-value-or-default inherited-subjects language default-subj)
                                            (localized-value-or-default subjects language default-subj))
        body                              (if inherit?
                                            (localized-value-or-default inherited-bodies language default-body)
                                            (localized-value-or-default bodies language default-body))
        import-id                         (str "system-email-template-import-" (name email-type))
        key                               (str "system-email-body-"
                                               (name email-type)
                                               "-"
                                               (name language)
                                               "-"
                                               inherit?
                                               "-"
                                               editor-version
                                               "-for-"
                                               group-id)]
    (when (and enabled? template)
      [acommon/admin-page
       {:match match
        :title (tr [:system-email-template/system-emails])}
       [:section.max-w-6xl
        [:div.flex.flex-col.md:flex-row.md:items-start.md:justify-between.gap-4
         [:div
          [:h2 (or (some-> (:name template) vector tr)
                   (tr [:system-email-template/system-emails]))]
          (when (and parent-group
                     (permission-resolver/permitted? parent-group
                                                     (<sub [:session/user])
                                                     :permission.group/admin))
            [:div.mt-2
             (cc/link {:href (href/href :view/group.admin.system-email-template
                                        {:group-id   (:db/id parent-group)
                                         :email-type (-> match :parameters :path :email-type)})}
                      (tr [(parent-template-key parent-group
                                                :system-email-template/view-organization-template
                                                :system-email-template/view-shared-services-template)]))])]
         [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}]]
        [:div.mt-6.grid.grid-cols-1.lg:grid-cols-3.gap-8
         [:div.lg:col-span-1.space-y-4
          [:div.rounded.border.border-gray-200.bg-gray-50.p-4
           [:h3.font-semibold.mb-3 (tr [:system-email-template/details])]
           [:div.text-sm.space-y-3
            [:div
             [:div.font-medium (tr [:system-email-template/recipient])]
             [:div.text-gray-700 (->> (:recipient template)
                                      (map #(tr [%]))
                                      (str/join ", "))]]
            [:div
             [:div.font-medium (tr [:system-email-template/attachments])]
             (if (seq attachments)
               [:ul.text-gray-700
                (for-frag [{:keys [label]} attachments]
                  [:li (tr [label])])]
               [:div.text-gray-700 (tr [:not-applicable])])]
            (when (seq placeholders)
              [:div
               [:div.font-medium (tr [:system-email-template/placeholders])]
               [:ul.mt-2
                (for-frag [placeholder placeholders]
                  [placeholder-view tr placeholder])]])]]]
         [:div.lg:col-span-2.space-y-4
          (when parent-group
            [:div.text-sm.w-max-2-3
             [cc/checkbox
              {:id         (str "inherit-system-email-" (name email-type))
               :label-text (tr [(parent-template-key parent-group
                                                     :system-email-template/use-template-from-organization
                                                     :system-email-template/use-template-from-shared-services)])
               :checked    inherit?
               :on-change  #(do
                              (>evt [::template-subs/set-system-email-template-inheritance
                                     group-id email-type (not inherit?)]))}]
             (when inherit?
               [:p.mt-1.text-gray-600
                (tr [(parent-template-key parent-group
                                          :system-email-template/inherited-template-help
                                          :system-email-template/inherited-shared-services-template-help)])])])
          [:div.flex.flex-wrap.justify-end.items-start.gap-4
           (when (:edited? template)
             [ui/modal-confirmation-button
              {:id                  (str "revert-system-email-template-" (name email-type))
               :tr                  tr
               :trigger-button-text (tr [:system-email-template/revert-to-default])
               :trigger-button-opts {:kind :danger}
               :dangerous?          true
               :on-yes-click        #(>evt [::template-subs/revert-system-email-template group-id email-type])}
              (tr [:system-email-template/revert-confirmation])])
           [upload/file-picker-button
            {:id           import-id
             :tr           tr
             :accept-types [".edn"]
             :button-opts  {:kind             :secondary
                            :icon             i/upload
                            :icon-description (tr [:system-email-template/import])}
             :on-select-fn (partial template-subs/import-system-email-template-file group-id email-type)}
            (tr [:system-email-template/import])]
           (cc/button {:kind             :secondary
                       :href             (file-download/download-href :group/export-system-email-template
                                                                      {:group-id   group-id
                                                                       :email-type email-type})
                       :icon             i/download
                       :icon-description (tr [:system-email-template/export])}
                      (tr [:system-email-template/export]))]
          [ui/text-input
           {:id          (str "system-email-subject-" (name email-type) "-" (name language))
            :label-text  (tr [:system-email-template/subject])
            :light       true
            :disabled    (or inherit? subject-readonly?)
            :value       (if subject-readonly? (or default-subj "") subject)
            :helper-text (cond
                           subject-readonly?
                           (tr [:system-email-template/subject-readonly-help])

                           (and (str/blank? subject) default-subj)
                           (str (tr [:system-email-template/default-subject]) ": " default-subj))
            :on-change   #(when-not subject-readonly?
                            (>evt [::template-subs/set-system-email-template-subject
                                   group-id email-type language (futil/tval %)]))}]
          ^{:key key}
          [ui-rt/editor
           (cond-> {:id                    key
                    :label-text            (tr [:system-email-template/body])
                    :initial-value         body
                    :template-placeholders placeholders}
             (not inherit?) (assoc :on-change #(>evt [::template-subs/set-system-email-template-body
                                                      group-id email-type language %])))]
          [:div.flex.justify-between.items-center.pt-2
           [ui/button
            {:kind     :tertiary
             :on-click #(>evt [::template-subs/preview-system-email-template group-id email-type])}
            (tr [:system-email-template/preview])]
           [:div.flex.gap-2
            [ui/button
             {:kind     :secondary
              :disabled (not dirty?)
              :on-click #(>evt [::template-subs/reset-system-email-template-draft group-id email-type])}
             (tr [:cancel])]
            [ui/button
             {:disabled (not dirty?)
              :on-click #(>evt [::template-subs/save-system-email-template group-id email-type])}
             (tr [:save])]]]]]
        (when preview
          (let [preview-subject (preview-value preview :subject)
                preview-body    (preview-value preview :body)]
            [cc/modal
             {:open             true
              :passive-modal    true
              :modal-heading    (tr [:system-email-template/preview])
              :on-request-close #(>evt [::template-subs/close-system-email-template-preview])}
             [cc/modal-body {}
              [:div.mb-4.rounded.border.border-gray-200.bg-gray-50.p-4
               [:div.text-xs.font-semibold.uppercase.tracking-wide.text-gray-600
                (tr [:system-email-template/subject])]
               [:div.mt-1.text-lg preview-subject]]
              [:iframe.w-full.rounded.border.border-gray-200.bg-white
               {:class "h-[70vh]"
                :src   (html-data-url preview-body)
                :title (str "system-email-preview-" (name email-type))}]]]))]])))
